import ProtectionPlansPen from './ProtectionPlansPen';

export default ProtectionPlansPen;
